import { Component } from '@angular/core';
import { TimelineDetailsComponent } from './modal-wrapper/timeline-details/timeline-details.component';
import {MatDialog} from '@angular/material/dialog';
import { TIMELINE_DATA } from 'src/assets/json/user-info';
@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class TimelineComponent {
  timelineData = TIMELINE_DATA;
  constructor(public dialog: MatDialog) {}

  displayDetails(id: string): void {

    const item = TIMELINE_DATA.find(t => t.id === +id);

    const openedModal = this.dialog.open(TimelineDetailsComponent, {
      height: 'auto',
      maxHeight: '90vh',
      width: 'md',
      data: item,
      disableClose: true
    });
    // this.subscription = openedModal.afterClosed().subscribe(() => this._router.navigateByUrl('/huzifaanjum'));
  }

}
